var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPentagon = function SvgPentagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M11.698 5.103a.5.5 0 0 1 .604 0l6.486 4.936c.18.137.256.38.187.602l-2.478 7.987a.54.54 0 0 1-.186.27.5.5 0 0 1-.302.102H7.99a.5.5 0 0 1-.302-.103.54.54 0 0 1-.186-.27l-2.478-7.986a.56.56 0 0 1 0-.333.54.54 0 0 1 .187-.269z"
  })));
};
export default SvgPentagon;